import { SlidePayFormConfig } from '../../../types';

export const slidePayDefaultFormConfig = (token: string): SlidePayFormConfig => ({
	token,
	amount: 0,
	fields: {
		cardNumber: {
			target: '#sp-card-number',
			useTargetStyle: false,
		},
		cardExpiration: {
			target: '#sp-card-exp',
			useTargetStyle: false,
		},
		cardCvv: {
			target: '#sp-card-cvv',
			useTargetStyle: false,
		},
		cardHolderName: {
			target: '#sp-cardholder-name',
			useTargetStyle: false,
		},
		submit: {
			target: '#submit-btn',
			useTargetStyle: false,
		},
	},
	styles: {
		'input[type=text]': {
			'font-size': '16px',
			'line-height': '42px',
			'background-position': '9px center',
			'background-repeat': 'no-repeat',
			'background-size': '18px 18px',
			display: 'block',
			height: '50px',
			'background-color': '#FFFFFF',
			border: '1px solid #FFFFFF',
			outline: 'none',
		},
		'input:focus, input:focus-visible, input:active': {
			border: '0px',
		},
		'button[type=submit]': {
			'pointer-events': 'all',
			cursor: 'pointer',
			color: '#fafcfb',
			padding: '5px',
			width: '20%',
			'background-color': '#1976d2',
			'font-size': '13px',
			'font-weight': 'light',
			'font-family': 'Arial',
			'box-sizing': 'border-box',
			'line-height': '1.75',
			'border-radius': '4px',
			'box-shadow':
				'0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
			border: '0',
			'border-color': '#2962ff',
			outline: '0',
			'letter-spacing': '0.5px',
			'text-transform': 'uppercase',
		},
		'button[type=submit]:hover': {
			'box-shadow': 'none',
		},
		'button[type=submit][disabled]': {
			background: '#6F9ED5',
			'box-shadow': 'none',
		},
		'.saveCard': {
			display: 'none',
		},
	},
});
